import AnnouncementBar from './AnnouncementBar';
import Header from './Header';
import Footer from './Footer';
import CartDrawer from '../cart/CartDrawer';
import MobileBottomNav from './MobileBottomNav';
import WhatsAppButton from '../common/WhatsAppButton';

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <AnnouncementBar />
    <Header />
    <CartDrawer />
    <main className="flex-1 pb-14 md:pb-0">{children}</main>
    <Footer />
    <MobileBottomNav />
    <WhatsAppButton />
  </div>
);

export default Layout;
